import { render, staticRenderFns } from "./AfterSaleDetail.vue?vue&type=template&id=8fed5ed4&scoped=true&"
import script from "./AfterSaleDetail.vue?vue&type=script&lang=js&"
export * from "./AfterSaleDetail.vue?vue&type=script&lang=js&"
import style0 from "./AfterSaleDetail.vue?vue&type=style&index=0&id=8fed5ed4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fed5ed4",
  null
  
)

component.options.__file = "AfterSaleDetail.vue"
export default component.exports